<template>
  <div class="container">
    <ControlGroup>
      <Dropdown :options="regions" v-model="region" label="Region" />
      <Dropdown :options="countryOptions" v-model="country" label="Country" />
    </ControlGroup>
    <div class="m-block m-block--charts m-block--charts-half">
      <DevelopmentPipeline :projects="filteredProjects" />
      <OperationalPlanned
        :projects="filteredProjects"
        :region="region"
        :country="country"
      />
    </div>
  </div>
</template>

<script>
import { ControlGroup, Dropdown } from "@international-energy-agency/vue-ui";
import OperationalPlanned from "./components/OperationalPlanned.vue";
import DevelopmentPipeline from "./components/DevelopmentPipeline.vue";

import projects from "./data/projects.json";

const countries = projects
  .reduce((countries, project) => {
    const projectCountries = project.country.split(",").map((c) => c.trim());
    projectCountries.forEach((country) => {
      if (!countries.includes(country)) countries.push(country);
    });
    return countries;
  }, [])
  .sort();

/**
 * Minimal component with Highcharts and IEA chart layout/options
 */
export default {
  name: "App",
  components: {
    ControlGroup,
    Dropdown,
    OperationalPlanned,
    DevelopmentPipeline,
  },
  data() {
    // Any values that do NOT depend on other app values can be defined in "data",
    // otherwise they have to be defined as "computed" values
    return {
      projects,
      region: "World",
      country: null,
      countries,
      series: [{ name: "Example", data: [1, 2, 3, 4] }],
    };
  },
  watch: {
    region(oldRegion, newRegion) {
      if (oldRegion !== newRegion) this.country = null;
    },
  },
  computed: {
    regions() {
      const { validProjects } = this;
      const regions = validProjects.reduce(
        (regions, project) =>
          regions.includes(project.region)
            ? regions
            : [...regions, project.region],
        []
      );
      return ["World", ...regions.sort()];
    },
    countryOptions() {
      const { region, countries, validProjects } = this;
      return [
        { label: "All", value: null },
        ...countries
          .filter((country) =>
            validProjects.some(
              (project) =>
                project.country.includes(country) &&
                (region === "World" || project.region === region)
            )
          )
          .map((country) => ({ label: country, value: country })),
      ];
    },
    validProjects() {
      return projects.filter(
        (project) =>
          !["Suspended/cancelled/decommissioned"].includes(project.status) &&
          project.capacity > 0
      );
    },
    filteredProjects() {
      const { region, country, validProjects } = this;
      if (country) {
        return validProjects.filter((project) =>
          project.country.includes(country)
        );
      }
      if (region !== "World") {
        return validProjects.filter((project) => project.region === region);
      }
      return validProjects;
    },
  },
};
</script>
